/**
 * @file
 * Theme javascript.
 */
(function ($) {

  function createUUID() {
    let dt = new Date().getTime();

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        const r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
      }
    );
  }

  function buildSplide(element, className = '') {
    if (!element.parent().is('.item-list')) {
      element.wrap('<div class="item-list"></div>');
    }

    const arrows = `
      <div class = "splide__arrows" >
        <button class = "splide__arrow splide__arrow--prev"> ${Drupal.t(
          'Prev'
        )} </button>
        <button class = "splide__arrow splide__arrow--next"> ${Drupal.t(
          'Next'
        )} </button>
      </div>
      <ul class = "splide__pagination" ></ul>`;
    const parent = element.parent();
    const uuid = createUUID();

    // Add class and wrap slide items.
    parent.addClass('splide__track');
    const htmlWrapper = `<div class = "splide ${className}" id = "splide-${uuid}"/>`;
    parent.wrapAll(htmlWrapper);

    // Add class to element wrapper.
    element.addClass('splide__list');

    // Add classes to children.
    element.children().addClass('splide__slide');

    element.parents('.splide').append(arrows);

    return uuid;
  }

  const mobile = $(window).innerWidth() < 1024;

  Drupal.behaviors.stickyHeader = {
    attach(context) {
      const header = $('header[role="banner"]', context);

      $(window).on('scroll', function () {
        if ($(window).scrollTop() > 40) {
          header.addClass('sticky');
        } else {
          header.removeClass('sticky');
        }
      });
    },
  };

  Drupal.behaviors.headerMenu = {
    attach(context) {
      const regionHeader = $('.region-header', context);
      const navs = $('.region-header > nav', context);
      const parentItem = $('.region-header .menu-item--expanded > a, .region-header .menu-item--expanded > span', context);

      $(document).on('click', '.hamburger', function (e) {
        e.preventDefault();
        regionHeader.toggleClass('open');
      });

      parentItem.on('click', function (e) {
        e.preventDefault();

        if ($(this).parent().hasClass('open')) {
          $(this).parent().removeClass('open');
        } else {
          $(this).parent().siblings().removeClass('open');
          $(this).parent().addClass('open');
        }
      });

      $(document).on('click', function (e) {
        if (!parentItem.is(e.target) && parentItem.parent().has(e.target).length === 0) {
          $('.region-header .menu-item--expanded', context).removeClass('open');
        }
      });
    },
  };

  Drupal.behaviors.accordeon = {
    attach(context) {
      const item = $('.item_accordeon', context);

      item.on('click', function () {
        if ($(this).hasClass('open')) {
          item.removeClass('open');
        } else {
          item.removeClass('open');
          $(this).toggleClass('open');

          setTimeout(() => {
            let offset = $(this).offset().top - $('header[role="banner"]').outerHeight();

            if ($('body').hasClass('toolbar-fixed')) {
              offset = offset - 39;
            }

            if ($('body').hasClass('toolbar-tray-open')) {
              offset = offset - 40;
            }

            window.scrollTo({top: offset});
          }, 100);
        }
      });
    },
  };

  Drupal.behaviors.pager = {
    attach(context) {
      const ellipsis = $('.pager__item--ellipsis', context);

      ellipsis.prev('.pager__item').removeClass('pager__item--before-ellipsis');
      ellipsis.next('.pager__item').removeClass('pager__item--after-ellipsis');

      ellipsis.each(function () {
        if ($(this).next().is('.pager__item--next')) {
          $(this).prev('.pager__item').addClass('pager__item--before-ellipsis');
        }

        if ($(this).prev().is('.pager__item--previous')) {
          $(this).next('.pager__item').addClass('pager__item--after-ellipsis');
        }
      });
    },
  };

  Drupal.behaviors.filters = {
    attach(context) {
      const filters = $('.filters', context);
      const filtersLabel = $('.filters .label', context);
      const details = $('.filters details', context);
      const goBack = $('.filters .retour-liste');

      var closeFilters = function () {
        filters.toggleClass('open');
      };

      filtersLabel.on('click', closeFilters);
      goBack.on('click', closeFilters);

      details.on('click', function () {
        details.not(this).removeAttr('open');
      });

      var activeFilters = $('.wrapper--content .filters .is-active').length;
      var $countElt = $('.filters .count');

      if (activeFilters) {
        $countElt.text(activeFilters);
        $countElt.addClass('filled');
      }
      else {
        $countElt.text('');
        $countElt.removeClass('filled');
      }
    },
  };

  Drupal.behaviors.paragraphListeContenus = {
    attach(context) {
      const nodes = $('.wrapper-specialite > .node', context);
      nodes.wrapAll('<div class="slider" />');
      const slider = $('.wrapper-specialite', context).find('.slider');

      if (!slider.length || nodes.length < 1) {
        return;
      }

      buildSplide(slider, 'wrapper-specialite-splide');
      new Splide(".wrapper-specialite .splide", {
        perPage: 1,
        perMove: 1,
        autoWidth: true,
        gap: "1rem",
        mediaQuery: "min",
        breakpoints: {
          1024: {
            perPage: 3,
            perMove: 3,
            gap: "2.875rem",
          },
        },
      }).mount();
    },
  };

  Drupal.behaviors.paragrapheSpecialistesSlider = {
    attach(context) {
      const $autres_specialistes = $(".autres-specialistes-liste > article", context);

      let min_items = mobile ? 2 : 4;

      if(mobile && $autres_specialistes.length == 1){
        return;
      }

      if ($autres_specialistes.length == 2) {
        $(".autres-specialistes-liste").addClass('-has-2-items');
      }

      $autres_specialistes.wrapAll('<div class="slider" />');
      const $autres_slider = $(".autres-specialistes-liste", context).find('.slider');

      if (!$autres_slider.length || $autres_specialistes.length < min_items) {
        return;
      }

      buildSplide($autres_slider, 'autres-specialistes-liste-splide');
      new Splide(".autres-specialistes-liste .splide", {
        perPage: 1,
        perMove: 1,
        autoWidth: true,
        arrows: true,
        gap: "1rem",
        mediaQuery: "min",
        breakpoints: {
          1024: {
            perPage: 3,
            gap: "3rem",
          },
        },
      }).mount();
    },
  };

  Drupal.behaviors.hno404 = {
    attach: function (context, settings) {

      const cta = once('hno404', '.field--name-field-label-previous-page, .config_pages--_04-generale--full .field--name-field-cta');

      if (cta.length) {
        cta[0].addEventListener('click', function (e) {
          e.preventDefault();

          if (document.referrer) {
            history.back();
          }
          else {
            window.location = '/';
          }
        });
      }
    }
  };

  Drupal.behaviors.paragrapheSpecialistes = {
    attach(context) {
      const paragrapheSpecialistes = $('.wrapper-paragraphes-specialistes', context);
      const nodes = $('.wrapper-paragraphes-specialistes .node--view-mode-fiche-specialiste', context);

      const masonry = paragrapheSpecialistes.find('.masonry');
      let column = 1;

      nodes.each(function (i) {
        const node = $(this).clone();
        if (nodes.length % 3 !== 0 && (i + 1) === nodes.length) {
          masonry.find('.column-2').append(node);
        } else {
          if (column === 1) {
            masonry.find('.column-1').append(node);
          }

          if (column === 2) {
            masonry.find('.column-2').append(node);
          }

          if (column === 3) {
            masonry.find('.column-3').append(node);
            column = 0;
          }

          column++;
        }
      });

      nodes.wrapAll('<div class="slider" />');
      const slider = paragrapheSpecialistes.find('.slider');

      $(document).on('click', '.wrapper-contact > h3', function () {
        $(this).parent().toggleClass('open');
      });

      let min_items = mobile ? 2 : 3;

      if (!slider.length || nodes.length < min_items) {
        if(nodes.length == 1) {
          slider.addClass("single-item");
        }
        return;
      }

      buildSplide(slider, 'wrapper-paragraphes-specialistes-splide');
      new Splide(".wrapper-paragraphes-specialistes .splide", {
        perPage: 1,
        perMove: 1,
        autoWidth: true,
        gap: "1rem",
        mediaQuery: "min",
        breakpoints: {
          1024: {
            perPage: 3,
            autoWidth: false,
          },
        },
      }).mount();

    },
  };

  Drupal.behaviors.search = {
    attach(context, settings) {
      const $searchWrapper_notopen = $("body:not(.search-open) .search-wrapper-mobile");
      const $labelMobile = $(".label-search");
      const $enterButton = $("#edit-actions--2");
      const $input = $("input.ui-autocomplete-input");
      const $resetSearch = $(".reset-search");
      const $dropwdown = $(".ui-menu.ui-widget.ui-widget-content");

      function common_functions($function_name, $options=null) {
        switch($function_name) {
          case 'remove_force_show':
            remove_force_show();
            break;

          case 'close_mobile_search_overlay':
            close_mobile_search_overlay();
            break;

          case 'toggle_exit':
            toggle_exit($options);
            break;
        }

        function remove_force_show() {
          if ($dropwdown.hasClass("show-mobile")) {
            $dropwdown.removeClass("show-mobile");
          }
        }

        function close_mobile_search_overlay() {
          $("#edit-recherche--2").autocomplete('close');
          $("body").removeClass("search-open");
        }

        function toggle_exit(visible) {
          if (visible) {
            $resetSearch.removeClass("hidden");
          } else {
            $resetSearch.addClass("hidden");
          }
        }
      }

      if(mobile){
        $labelMobile.text("Recherche");

        $searchWrapper_notopen.on("click", function () {
          $("body").addClass("search-open");
        });

        $labelMobile.on("click", function (e) {
          e.stopPropagation();
          $input.val("");
          common_functions('toggle_exit', false);
          common_functions('close_mobile_search_overlay');
        });

        $resetSearch.on("click", function () {
          common_functions('remove_force_show');
        });

        $enterButton.on("click", function () {
          common_functions('remove_force_show');

          setTimeout(function () {
            common_functions('close_mobile_search_overlay');
          }, 300);

        });
      }

      $input
      .on("focus click keyup", function (e) {
        if($(this).val()){
          common_functions('toggle_exit', true);

          if (mobile) {
            if($(this).val().length > 1) {
              $dropwdown.addClass("show-mobile");
            } else {
              common_functions('remove_force_show');
            }
          }

        }else {
          common_functions('toggle_exit', false);
        }

        if (e.which == 13 && $("body").hasClass("search-open")) {
          common_functions('remove_force_show');
          common_functions('close_mobile_search_overlay');
          return false;
       }
      });
    },
  };

  Drupal.behaviors.videoPlayer = {
    attach(context, settings) {
      const overlay = $(".paragraph.paragraph--type--embed-video, .paragraph.paragraph--type--embed-video img");

      overlay.on("click", function(e){
        e.stopPropagation();
        if($(this).parents(".paragraph.paragraph--type--embed-video").length) {
          $(this).parents(".paragraph.paragraph--type--embed-video").addClass("active");
        } else {
          $(this).addClass("active");
        }
      });
    },
  };

  Drupal.behaviors.chiffreSlider = {
    attach(context, settings) {
      const $chiffres = $(".paragraph--type--slider-chiffre-cle .field--name-field-slider-chiffre-cle");
      let counter = 0;

      $chiffres.each(function(){
        const $sliderNodes = $(this).find(">.field__item");
        $sliderNodes.wrapAll('<div class="slider" />');
        const slider = $($(this), context).find('.slider');

        if (!slider.length || $sliderNodes.length < 1) {
          return;
        }

        buildSplide(slider, 'chiffre-slider-splide');

        $(this).find(".splide").attr("id", "splide"+counter);
        new Splide("#splide"+counter++, {
          perPage: 1,
          perMove: 1,
          gap: "1rem",
          mediaQuery: "min",
          rewind: false,
          autoHeight: true,
          breakpoints: {
            1024: {
              perPage: 3,
              perMove: 1,
              gap: "2.875rem",
              autoHeight: true,
            },
          },
        }).mount().refresh();
      });


    },
  };

  Drupal.behaviors.recrutementSlider = {
    attach(context, settings) {
      const $offres = $(".config_pages--type--recrutement .field--name-field-offres-une");
      if($(window).innerWidth() < 1024) {
        $offres.each(function(){
          const $sliderNodes = $(this).find(">.field__item");
          $sliderNodes.wrapAll('<div class="slider" />');
          const slider = $($(this), context).find('.slider');

          if (!slider.length || $sliderNodes.length < 1) {
            return;
          }

          buildSplide(slider, 'recrutement-slider-splide');
          new Splide(".config_pages--type--recrutement .field--name-field-offres-une .splide", {
            perPage: 1,
            perMove: 1,
            gap: "1rem",
            mediaQuery: "min",
            rewind: false,
          }).mount();
        });
      }
    },
  };

  Drupal.behaviors.paragraphSlider = {
    attach(context, settings) {
      const $paragraphSlider = $(".paragraph--type--slider");
      $paragraphSlider.each(function(){
        const $sliderNodes = $(this).find(">.field__items >.field__item");

        $sliderNodes.wrapAll('<div class="slider" />');

        const slider = $($(this), context).find('.slider');

        if (!slider.length || $sliderNodes.length < 1) {
          return;
        }

        buildSplide(slider, 'paragraph--type--slider-splide');
        new Splide(".paragraph--type--slider .splide", {
          perPage: 1.5,
          perMove: 1,
          gap: "1rem",
          mediaQuery: "min",
          rewind: false,
          autoHeight: true,
          breakpoints: {
            1024: {
              perPage: 1.5,
              perMove: 1,
              gap: "1.5rem",
              autoHeight: true,
            },
          },
        }).mount();

        //Image slider modal popup (desktop only)

        if($(window).innerWidth() >= 1024) {

          const modal_html = `
          <div class='image-modal hidden'>
          <div class='modal-slider'>

          </div>
          </div>`;

          $("body").append(modal_html);

          let $modal = $(".image-modal");
          let $modal_slider = $(".image-modal .modal-slider", context);

          $(this).find(".field__item > article.media").each(function(){
            $(this).append("<div class='show-img-modal'></div>");

            $(this).find(".show-img-modal").on("click", function(){
              $modal.prepend("<div class='close-modal'></div>");
              const position = $(this).parents(".field__item.splide__slide").prevAll().length;
              let article = $(this).parent("article.media");

              //Append all prev slides
              let allPrevious = article.parent(".field__item").prevAll().find(">article.media");
              if(allPrevious.length) {
                allPrevious.each(function() {
                  $modal_slider.append($(this).clone());
                });
              }

              //Append current slide
              $modal_slider.append(article.clone());

              //Append all next slides
              let allNext = article.parent(".field__item").nextAll().find(">article.media");
              if(allNext.length) {
                allNext.each(function() {
                  $modal_slider.append($(this).clone());
                });
              }

              //After all that, replace src of these images
              $modal_slider.find("article.media").each(function(){
                const newSrc = $(this).attr("data-original");

                $(this).find("source").attr("srcset", newSrc);
                $(this).find("img").attr("src", newSrc);
              });

              buildSplide($modal_slider, 'modal-slider-splide');
              const modalSplide = new Splide(".image-modal .splide", {
                perPage: 1,
                perMove: 1,
                start: position,
                width: "878px",
                autoHeight: true,
                rewind: false,
              }).mount();
              $modal.removeClass("hidden");

              modalSplide.refresh();

              $(".close-modal").on("click", function(e){
                //Remove current modal, append new one and reset vars
                $modal.remove();
                $("body").append(modal_html);

                $modal = $(".image-modal");
                $modal_slider = $(".image-modal .modal-slider", context);
              });
            });
          });
        }
      });
    },
  };

  let currentHost = window.location.origin;

  // Open external links in a new tab.
  $("a[href^='http://'], a[href^='https://']").attr("target","_blank");
  // Don't open in new tab in case of summary link
  $("a[href^='" + currentHost + "']").attr("target","_self");

  Drupal.behaviors.summaryEdito = {
    attach(context, settings) {
      //Adding bullet and progress line on links
      let link = $("a.summary-link", context);
      const bulletSpan = '<span class="bullet-js"></span>';
      const progressLine = '<span class="progress-line-js"></span>';
      link.before(bulletSpan);
      link.after(progressLine);

      //Scroll and class management
      var titlePositions = [];
      let viewportHeight = $(window).height();

      $('.summary-link').click(function(e) {
        e.preventDefault();
        let destinationUrl = $(this).attr('href');
        let destinationId = destinationUrl.substring(destinationUrl.indexOf('#') + 1);

        $('html, body').animate({
          scrollTop: $("#"+destinationId).offset().top - 400
        },10);
      });

      function getTitlePos() {
       $('.page-node-type-edito .field--name-field-paragraphes .paragraph--type--texte h2:first-of-type').each(function( index, element ) {
         var titleOffset = $(element).offset().top;
         titlePositions.push(titleOffset);
       });
      }

      $(window).on('scroll', function() {
        let scrollPos = $(window).scrollTop();
        var booleanArray = [];

        $('.summary-link').each(function(index, element) {
          var titleTop = titlePositions[index];

          if (titleTop < scrollPos + (viewportHeight - 400)) {
            $(element).parent().addClass('-consulted');
            booleanArray.push(titleTop < scrollPos + (viewportHeight - 400));

            if (index === booleanArray.length -1) {
              $(element).parent().addClass('-active');

              if (booleanArray.length > 0) {
                $(".summary-wrapper.item-list > ul > li:lt(" + (booleanArray.length - 1) + ")").removeClass('-active');
              }
            }
          }
          else {
            $(element).parent().removeClass('-consulted -active');
          }
        });

      });

      $(window).on('resize', function(){
        titlePositions.length = 0;
        getTitlePos();
      });

      getTitlePos();
    },
  };

})(jQuery);
